import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import LinkIcon from '@mui/icons-material/Link';
import { ICellRendererParams } from 'ag-grid-community';
import { FC, memo, useMemo } from 'react';
import { useShowAumniData } from '../../../hooks/useShowAumniData';
import { IFinanceRoundDataModel } from '../../../data-models/finance-round.data-model';
import { getRoundLabel } from '../../../util/preference-utils';
import { useInvestmentModalActions } from '../hooks/useFinanceModalActions';
import { IMenuItem, MenuButton } from './MenuButton';

export const InvestmentMenuCell: FC<ICellRendererParams<IFinanceRoundDataModel>> = memo(
  function InvestmentMenuCell({ data: selectedInvestment }: ICellRendererParams<IFinanceRoundDataModel>) {
    const { handleClickAction } = useInvestmentModalActions();
    const showAumniData = useShowAumniData();
    const menuItems = useMemo(() => {
      const roundLabel = getRoundLabel();
      if (!selectedInvestment) {
        return [];
      }
      const items: IMenuItem[] = [
        {
          name: `Edit ${roundLabel}`,
          icon: <EditOutlinedIcon aria-label={`Edit ${roundLabel}`} />,
          onClick: () => {
            handleClickAction(selectedInvestment, 'editInvestment');
          },
        },
      ];
      if (showAumniData) {
        items.push({
          name: 'Link Aumni Data',
          icon: <LinkIcon aria-label='Link Aumni Data' />,
          onClick: () => {
            handleClickAction(selectedInvestment, 'linkAumni');
          },
          divider: true,
        });
      }
      items.push({
        name: `Delete ${roundLabel}`,
        icon: <DeleteOutlinedIcon aria-label={`Delete ${roundLabel}`} />,
        onClick: () => {
          handleClickAction(selectedInvestment, 'deleteInvestment');
        },
      });
      return items;
    }, [handleClickAction, selectedInvestment, showAumniData]);

    if (!selectedInvestment) {
      return null;
    }

    return <MenuButton menuItems={menuItems} label='investment actions' />;
  }
);
